import { flex, Input, SegmentedControl, Select } from '@byecode/ui'
import styled from 'styled-components'

export const Container = styled.div``

export const FieldIcon = styled.div<{ color?: string }>`
    width: 32px;
    height: 32px;
    border: 1px solid var(--color-gray-200);
    border-radius: 5px;
    display: flex;
    justify-content: center;
    align-items: center;
    box-sizing: border-box;
    margin-right: 6px;
`

export const Text = styled.span<{ color?: string; bold?: boolean }>`
    font-weight: ${({ bold }) => (bold ? 'bold' : 'normal')};
    color: ${({ color }) => color ?? 'var(--color-gray-900)'};
    font-size: var(--font-size-normal);
`

export const RightFill = styled.div`
    position: relative;
    flex: 1;
    ${flex}
    justify-content: flex-end;
    align-items: center;
`

export const ViewSettingsInput = styled(Input)``
